import React from 'react';
import { Button, ButtonMembership, Dialog, T } from '@colonist/ui';
import IconDisableAdBlock from '@static/images/icon_no_ads.svg';
import styles from './DismissibleAdblockDialog.module.scss';
/** Dismissible dialog asking users to disable adblock. */ export function DismissibleAdblockDialog({ open, onClose, onDisableAdblock, onBecomeMember }) {
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "md"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: IconDisableAdBlock,
            alt: 'strings:popups.disableAdBlock.title'
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.title'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.softPopupBody'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        size: "md",
        fullWidth: true,
        onClick: onDisableAdblock
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.disableButton'
        }
    })), /*#__PURE__*/ React.createElement(ButtonMembership, {
        variant: "plus",
        size: "md",
        fullWidth: true,
        onClick: onBecomeMember
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.becomeMemberButton'
        }
    }))));
}
